// Sending an email to a vendor or customer (jobq-api "WHO SENDS AN EMAIL", since 2026-10-26).
//
// The shared API key ships in this bundle, so jobq-api's email routes (PO / admin PO / OPO / service RFQ;
// invoice / statement / quote / sales order, and the SO shipping-email resend) take the admin session's
// PIN on the request (X-Admin-Pin) and answer 401 without it. Every page with one of those buttons is
// behind the admin unlock, so the PIN is already in this tab: nobody is asked for anything new.
// Spread emailSenderHeaders() into the headers of EVERY call to those routes.

import { adminPinFromSession } from './securityApi';

/** {'X-Admin-Pin': pin} from the admin session, or {} when this tab has no admin unlock. */
export function emailSenderHeaders() {
  const pin = adminPinFromSession();
  return pin ? { 'X-Admin-Pin': pin } : {};
}
